module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "clearable": "",
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Value,
      attrs: {
        "disabled": ((_vm.entity == 'new_projectapply' || _vm.entity == 'new_authorizationletter') && _vm.attribute == 'new_band' && item.Value == 3),
        "label": item.Text,
        "value": item.Value
      }
    }, [_vm._v(_vm._s(item.Text))])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e70a9786"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/picklist/src/main.vue
// module id = 1551
// module chunks = 124